<template>
    <div>
        <h2 class="h2">{{ t('step3.title') }}</h2>
        <p>{{ t('paymentOnLocation') }}</p>
        <p>{{ t('orderIsConfirmed') }}</p>
        <DSInput
            v-model="order.data.value.contact"
            :label="t('step3.contactPerson')"
            :help-text="t('dsform.required')"
            :error="order.errors.value.contact"
        />
        <DSInput
            v-model="order.data.value.phone"
            :label="t('step3.phone')"
            :help-text="t('dsform.required')"
            :error="order.errors.value.phone"
        />
        <DSInput
            v-model="order.data.value.email"
            :label="t('step3.email')"
            :help-text="t('dsform.required')"
            :error="order.errors.value.email"
        />
    </div>
</template>
<script setup>
import { inject, useI18n } from '#imports';

const order = inject('order');

const { t } = useI18n({
    useScope: 'global',
    messages: {
        'fi-FI': {
            step3: {
                title: 'Tilaajan yhteystiedot',
                contactPerson: 'Yhteyshenkilö',
                address: 'Osoite',
                phone: 'Puhelinnumero',
                email: 'Sähköposti',
                confirmEmail: 'Asema varmistaa tilauksesi sähköpostitse, varmista sähköpostiosoitteesi',
                emailConfirmed: 'Olen tarkistanut sähköpostiosoitteeni',
            },
        },
    },
});
</script>
